// Free or Amari Plus: asks the server (snapcook_my_plan) and caches the answer on this device.
// Only an existing session is asked; this never creates one, so a first launch stays offline-fast.

import { hasBackend } from '../lib/config';
import { getSupabase } from '../lib/supabase';
import { useStore } from './store';

export async function refreshMembership(): Promise<void> {
  if (!hasBackend) return;
  try {
    const sb = await getSupabase();
    const { data: session } = await sb.auth.getSession();
    if (!session.session) return;
    const { data, error } = await sb.rpc('snapcook_my_plan');
    if (error || !data) return;
    useStore.getState().setMembership((data as { plan?: string }).plan === 'plus' ? 'plus' : 'free');
  } catch {
    // Offline: keep the cached answer.
  }
}
